import React from "react";
import { Navigation } from "../components/navigation";
import { CarwashProduct } from "../components/carwash-product";
import { CarwashFeatures } from "../components/carwash-features";
import { CardsSec3 } from "../components/cards-sec3";
import { CarwashEquipment } from "../components/carwash-equipment";
import { CarwashContact } from "../components/carwash-contact";
//import { CTA } from "../components/cta";
import { Footer } from "../components/footer";

export const CarwashPage = () => {
  return (
    <div>
      <Navigation />
      <CarwashProduct />
      <CarwashEquipment />
      <CarwashContact product="Car Wash Pay Station" industry="car-wash" />
      <CarwashFeatures />
      <CardsSec3 />
      <Footer />
    </div>
  );
};